module.exports = __webpack_public_path__ + "media/images/flags/1x1/ggy-bb5fec278ebccf1d7f161cedd40bf0d2.svg";